export default __webpack_public_path__ + "static/media/meal4.2503536b.svg";